import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { colors, spacing } from "../../constants";

export const AboutContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  align-items: center;

  padding: ${spacing.paddingMedium};
  margin: 0;
  border: none;
  gap: ${spacing.gapLarge};

  background-color: ${colors.primaryWhite};
`;

export const MissionContainer = styled(motion.section)`
  margin-top: 200px;
  text-align: center;
  max-width: 65vw;
  padding: 50px 20px;
  background: linear-gradient(
    135deg,
    ${colors.gradientStart},
    ${colors.gradientEnd}
  );
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
`;

export const MissionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${colors.primaryWhite};
  margin-bottom: 20px;
`;

export const MissionText = styled.p`
  font-size: 1.2rem;
  color: ${colors.primaryBlack};
  line-height: 1.6;
  margin-bottom: 15px;
`;

export const Highlight = styled.span`
  color: ${colors.accentNeonBlue};
  font-weight: 600;
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const SocialProofContainer = styled(motion.section)`
  max-width: 90vw;
  margin: 0 auto;
  text-align: center;
  padding: 60px 20px;
  border-radius: 12px;
`;

export const SectionTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: bold;
  color: ${colors.neutralDark};
  margin-bottom: 30px;
  text-align: center;
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
`;

export const StatBox = styled(motion.div)`
  text-align: center;
  flex: 1;
  min-width: 120px;
`;

export const StatNumber = styled(motion.span)`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${colors.accentNeonBlue};
  display: block;
`;

export const StatLabel = styled.p`
  font-size: 1.2rem;
  color: ${colors.primaryDark};
  margin-top: 5px;
`;

export const FoundersSection = styled(motion.section)`
  margin-top: 50px;
`;

export const FoundersContainer = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

export const FounderCard = styled(motion.div)`
  background: white;
  padding: 15px;
  border-radius: 10px;
  width: 200px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
`;

export const FounderImage = styled.img`
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 100%;
`;

export const FounderName = styled.h3`
  font-size: 1.4rem;
  font-weight: bold;
  color: ${colors.primaryDark};
  margin-top: 10px;
`;

export const FounderRole = styled.p`
  font-size: 1.2rem;
  color: ${colors.primaryGray};
`;

export const FounderDescription = styled.p`
  font-size: 1rem;
  color: ${colors.primaryBlack};
  margin-top: 10px;
`;

export const JourneySection = styled(motion.section)`
  max-width: 90vw;
  margin: 0 auto;
  padding: 30px;
  text-align: center;
  background: ${colors.primaryLight};
  border-radius: 12px;
`;

export const JourneyList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0;
  position: relative;

  ::before {
    content: "";
    position: absolute;
    left: 20px;
    top: 0;
    height: 100%;
    width: 4px;
    background-color: ${colors.accentNeonBlue};
  }
`;

export const JourneyItem = styled(motion.li)`
  display: flex;
  align-items: center;
  margin: 20px 0;
  padding-left: 50px;
  position: relative;
`;

export const TimelineMarker = styled.span`
  width: 14px;
  height: 14px;
  background-color: ${colors.accentNeonBlue};
  border-radius: 50%;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.6);
`;

export const JourneyItemSpan = styled.span`
  font-size: 1.1rem;
  background: #f8f9fa;
  color: var(--primary-black);
  padding: 10px 15px;
  border-radius: 5px;
  width: 100%;
  text-align: start;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
`;
